import { HeaderContainer } from "./container";

export const HEADER_HEIGHT = 64;

export { HeaderContainer as Header };
